import {
  take,
  put,
  call,
  all,
  takeLatest,
  takeEvery,
} from 'redux-saga/effects';
import { employeeActions as actions, notificationActions } from '../actions';
import { employeeService } from '../services';



/* Get All Employee Sagas */
function* handleGetAllEmployeeRequest() {
  const action = yield take(actions.getAllEmployeeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.getAllEmployee, dataParams);

    if (res.isError) {
      yield put(actions.getAllEmployeeError(res));

    } else {
      yield put(actions.getAllEmployeeSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllEmployeeError());
  }
}

/* Get Employee For Reporting Manager Sagas */
function* handleGetEmployeeForReportingManagerRequest() {
  const action = yield take(actions.getEmployeeForReportingManagerRequest.getType());
  let res;
  try {
    res = yield call(employeeService.getEmployeeForReportingManager);

    if (res.isError) {
      yield put(actions.getEmployeeForReportingManagerError(res));

    } else {
      yield put(actions.getEmployeeForReportingManagerSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEmployeeForReportingManagerError());
  }
}

// create employee
function* handleCreateEmployeeRequest() {
  const action = yield take(actions.createEmployeeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.createEmployee, dataParams);
    if (res.isError) {
      yield put(actions.createEmployeeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.createEmployeeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

    }
  } catch (error) {
    yield put(actions.createEmployeeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

  }
}

// -----------Watchers-------------

/* Get User On Role Sagas */
function* handleGetUserOnRoleRequest() {
  const action = yield take(actions.getUserOnRoleRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.getUserOnRole, dataParams);

    if (res.isError) {
      yield put(actions.getUserOnRoleError(res));

    } else {
      yield put(actions.getUserOnRoleSuccess(res));
    }

  } catch (error) {
    yield put(actions.getUserOnRoleError());
  }
}

/* Get Profile Sagas */
function* handleGetProfileRequest() {
  const action = yield take(actions.getProfileRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.getProfile, dataParams);

    if (res.isError) {
      yield put(actions.getProfileError(res));

    } else {
      yield put(actions.getProfileSuccess(res));
    }

  } catch (error) {
    yield put(actions.getProfileError());
  }
}

/* Aadhar Verfy Sagas */
function* handleAadhaarVerifyRequest() {
  const action = yield take(actions.aadhaarVerifyRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.aadhaarVerify, dataParams);

    if (res.isError) {
      yield put(actions.aadhaarVerifyError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    } else {
      yield put(actions.aadhaarVerifySuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.aadhaarVerifyError());
  }
}


/* Get All Employee List Sagas */
function* handleGetAllEmployeeListRequest() {
  const action = yield take(actions.getAllEmployeeListRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.getAllEmployeeList, dataParams);
    if (res.isError) {
      yield put(actions.getAllEmployeeListError(res));

    } else {
      yield put(actions.getAllEmployeeListSuccess(res));
    }

  } catch (error) {
    yield put(actions.getAllEmployeeListError());
  }
}

/*  update Employee Details Request Sagas */
function* handleUpdateEmployeeDetailsRequest() {
  const action = yield take(actions.updateEmployeeDetailsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.updateEmployeeDetails, dataParams);
    if (res.isError) {
      yield put(actions.updateEmployeeDetailsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.updateEmployeeDetailsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

    }

  } catch (error) {
    yield put(actions.updateEmployeeDetailsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'success' }));
  }
}


/* Bulk Upload employee Sagas */
function* handleBulkUpdateEmployeeRequest() {
  const action = yield take(actions.bulkUpdateEmployeeRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.bulkUpdateEmployee, dataParams);
    if (res.isError) {
      yield put(actions.bulkUpdateEmployeeError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.bulkUpdateEmployeeSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.bulkUpdateEmployeeError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}

/* Resume Parser Sagas */
function* handleResumeParserRequest() {
  const action = yield take(actions.resumeParserRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.resumeParser, dataParams);
    if (res.isError) {
      yield put(actions.resumeParserError(res));

    } else {
      yield put(actions.resumeParserSuccess(res));
    }

  } catch (error) {
    yield put(actions.resumeParserError());
  }
}


/* Get Generate Employee Id Sagas */
function* handleGenerateEmployeeIdRequest() {
  const action = yield take(actions.generateEmployeeIdRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.generateEmployeeId, dataParams);
    if (res.isError) {
      yield put(actions.generateEmployeeIdError(res));

    } else {
      yield put(actions.generateEmployeeIdSuccess(res));
    }

  } catch (error) {
    yield put(actions.generateEmployeeIdError());
  }
}

/* get Employee By Department Sagas */
function* handleGetEmployeeByDepartmentRequest() {
  const action = yield take(actions.getEmployeeByDepartmentRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.getEmployeeByDepartment, dataParams);
    if (res.isError) {
      yield put(actions.getEmployeeByDepartmentError(res));

    } else {
      yield put(actions.getEmployeeByDepartmentSuccess(res));
    }

  } catch (error) {
    yield put(actions.getEmployeeByDepartmentError());
  }
}
/* get Employee By Department Sagas */
function* handleGetEmployeeHistoryRequest() {
  const action = yield take(actions.getEmployeeHistoryRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.getEmployeeHistory, dataParams);
    if (res.isError) {
      yield put(actions.getEmployeeHistoryError(res));

    } else {
      yield put(actions.getEmployeeHistorySuccess(res));
    }

  } catch (error) {
    yield put(actions.getEmployeeHistoryError());
  }
}


/* get Employee By Department Sagas */
function* handleSendEmployeeCredentialsRequest() {
  const action = yield take(actions.sendEmployeeCredentialsRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.sendEmployeeCredentials, dataParams);
    if (res.isError) {
      yield put(actions.sendEmployeeCredentialsError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.sendEmployeeCredentialsSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.sendEmployeeCredentialsError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}


/* Upload Profile Sagas */
function* handleUploadProfileRequest() {
  const action = yield take(actions.uploadProfileRequest.getType());
  const dataParams = action.payload;
  let res;
  try {
    res = yield call(employeeService.uploadProfile, dataParams);
    if (res.isError) {
      yield put(actions.uploadProfileError(res));
      yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    } else {
      yield put(actions.uploadProfileSuccess(res));
      yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
    }

  } catch (error) {
    yield put(actions.uploadProfileError());
    yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
  }
}
/* -----------Watchers------------- */
function* handleGetAllEmployeeWatcher() {
  yield takeEvery(
    actions.getAllEmployeeRequest,
    handleGetAllEmployeeRequest,
  );
}

function* handleGetEmployeeForReportingManagerWatcher() {
  yield takeEvery(
    actions.getEmployeeForReportingManagerRequest,
    handleGetEmployeeForReportingManagerRequest,
  );
}

function* handleCreateEmployeeWatcher() {
  yield takeEvery(
    actions.createEmployeeRequest,
    handleCreateEmployeeRequest,
  )
}

function* handleGetUserOnRoleWatcher() {
  yield takeEvery(
    actions.getUserOnRoleRequest,
    handleGetUserOnRoleRequest,
  );
}

function* handleGetProfileWatcher() {
  yield takeEvery(
    actions.getProfileRequest,
    handleGetProfileRequest,
  );
}

function* handleAadhaarVerifyWatcher() {
  yield takeEvery(
    actions.aadhaarVerifyRequest,
    handleAadhaarVerifyRequest,
  );
}

function* handleGetAllEmployeeListWatcher() {
  yield takeEvery(
    actions.getAllEmployeeListRequest,
    handleGetAllEmployeeListRequest,
  );
}

function* handleUpdateEmployeeDetailsWatcher() {
  yield takeEvery(
    actions.updateEmployeeDetailsRequest,
    handleUpdateEmployeeDetailsRequest,
  );
}

function* handleBulkUpdateEmployeeWatcher() {
  yield takeEvery(
    actions.bulkUpdateEmployeeRequest,
    handleBulkUpdateEmployeeRequest,
  );
}

function* handleResumeParserWatcher() {
  yield takeEvery(
    actions.resumeParserRequest,
    handleResumeParserRequest,
  );
}

function* handleGenerateEmployeeIdWatcher() {
  yield takeEvery(
    actions.generateEmployeeIdRequest,
    handleGenerateEmployeeIdRequest,
  );
}

function* handleGetEmployeeByDepartmentWatcher() {
  yield takeEvery(
    actions.getEmployeeByDepartmentRequest,
    handleGetEmployeeByDepartmentRequest,
  );
}

function* handleGetEmployeeHistoryWatcher() {
  yield takeEvery(
    actions.getEmployeeHistoryRequest,
    handleGetEmployeeHistoryRequest,
  );
}

function* handleSendEmployeeCredentialsWatcher() {
  yield takeEvery(
    actions.sendEmployeeCredentialsRequest,
    handleSendEmployeeCredentialsRequest,
  );
}

function* handleUploadProfileWatcher() {
  yield takeEvery(
    actions.uploadProfileRequest,
    handleUploadProfileRequest,
  );
}


function* rootEmployeeSaga() {
  yield all([

    handleGetAllEmployeeRequest(),
    handleGetAllEmployeeWatcher(),

    handleGetEmployeeForReportingManagerRequest(),
    handleGetEmployeeForReportingManagerWatcher(),

    handleCreateEmployeeRequest(),
    handleCreateEmployeeWatcher(),

    handleGetUserOnRoleRequest(),
    handleGetUserOnRoleWatcher(),

    handleGetProfileRequest(),
    handleGetProfileWatcher(),

    handleAadhaarVerifyRequest(),
    handleAadhaarVerifyWatcher(),

    handleGetAllEmployeeListRequest(),
    handleGetAllEmployeeListWatcher(),

    handleUpdateEmployeeDetailsRequest(),
    handleUpdateEmployeeDetailsWatcher(),

    handleBulkUpdateEmployeeRequest(),
    handleBulkUpdateEmployeeWatcher(),

    handleGenerateEmployeeIdRequest(),
    handleGenerateEmployeeIdWatcher(),

    handleResumeParserRequest(),
    handleResumeParserWatcher(),

    handleGetEmployeeByDepartmentRequest(),
    handleGetEmployeeByDepartmentWatcher(),

    handleGetEmployeeHistoryRequest(),
    handleGetEmployeeHistoryWatcher(),

    handleSendEmployeeCredentialsRequest(),
    handleSendEmployeeCredentialsWatcher(),

    handleUploadProfileRequest(),
    handleUploadProfileWatcher(),

  ]);
}
export default rootEmployeeSaga;

